'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createItemConfigObject = createItemConfigObject;
exports.createOnboardingItemConfig = createOnboardingItemConfig;
exports.defaultAdditionalContactsUnitItemConfig = defaultAdditionalContactsUnitItemConfig;
exports.defaultAdditionalSeatsUnitItemConfig = defaultAdditionalSeatsUnitItemConfig;
exports.createAdditionalUnitsItemConfig = createAdditionalUnitsItemConfig;
exports.createItemConfigWithAdditionalUnits = createItemConfigWithAdditionalUnits;
exports.createItemConfigWithMandatoryMerch = createItemConfigWithMandatoryMerch;
exports.createSuiteItemConfigs = createSuiteItemConfigs;
exports.createSuiteItemConfigsWithRequiredOnboarding = createSuiteItemConfigsWithRequiredOnboarding;

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _PurchaseTypes = require('self-service-api/constants/PurchaseTypes');

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _merchandiseUtils = require('./merchandiseUtils');

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _GrowthSuiteEditionOnboardingMerchIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionOnboardingMerchIdMap');

var _GrowthSuiteEditionOnboardingMerchIdMap2 = _interopRequireDefault(_GrowthSuiteEditionOnboardingMerchIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createItemConfigObject(_ref) {
  var merchandiseId = _ref.merchandiseId,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === undefined ? 1 : _ref$quantity;

  return {
    merchandiseId: merchandiseId,
    quantity: quantity
  };
}

function createOnboardingItemConfig(_ref2) {
  var merchandiseId = _ref2.merchandiseId,
      requiredOnboarding = _ref2.requiredOnboarding;

  var requiredOnboardingMerchandiseId = requiredOnboarding[merchandiseId] && requiredOnboarding[merchandiseId].onboardingMerchandiseId;
  if (!requiredOnboardingMerchandiseId) return [];
  var onboardingItemConfig = [createItemConfigObject({
    merchandiseId: requiredOnboardingMerchandiseId,
    quantity: 1
  })];
  return onboardingItemConfig;
}

function defaultAdditionalContactsUnitItemConfig(merchandiseId) {
  return [createItemConfigObject({
    merchandiseId: (0, _merchandiseUtils.getMerchandiseMap)(merchandiseId).additionalUnitMerchId,
    quantity: (0, _merchandiseUtils.includedAdditionalUnits)(merchandiseId) + 1000
  })];
}

function defaultAdditionalSeatsUnitItemConfig(merchandiseId) {
  return [createItemConfigObject({
    merchandiseId: (0, _merchandiseUtils.getMerchandiseMap)(merchandiseId).additionalUnitMerchId,
    quantity: 1
  })];
}

// Note: This is only for use when the additional unit merchandise id is
// different from the merchandise id. In the case of Sales/Service Starter
// or Sales Pro Legacy, only one item config should be generated with the
// full quantity.
function createAdditionalUnitsItemConfig(_ref3) {
  var merchandiseId = _ref3.merchandiseId,
      additionalUnitQuantity = _ref3.additionalUnitQuantity;

  return createItemConfigObject({
    merchandiseId: (0, _merchandiseUtils.getMerchandiseMap)(merchandiseId).additionalUnitMerchId,
    quantity: additionalUnitQuantity
  });
}

function createItemConfigWithAdditionalUnits(_ref4) {
  var merchandiseId = _ref4.merchandiseId,
      additionalUnitQuantity = _ref4.additionalUnitQuantity;

  if (!additionalUnitQuantity) {
    return [createItemConfigObject({ merchandiseId: merchandiseId, quantity: 1 })];
  }
  if ((0, _merchUtils.isAdditionalUnitsMerchIdSameAsBaseMerchId)(merchandiseId)) {
    return [createItemConfigObject({
      merchandiseId: merchandiseId,
      quantity: additionalUnitQuantity + 1
    })];
  }

  return [createItemConfigObject({ merchandiseId: merchandiseId }), createAdditionalUnitsItemConfig({
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity
  })];
}

// Returns itemConfigs with base merch, additional units, and onboarding
function createItemConfigWithMandatoryMerch(_ref5) {
  var merchandiseId = _ref5.merchandiseId,
      additionalUnitQuantity = _ref5.additionalUnitQuantity,
      requiredOnboarding = _ref5.requiredOnboarding,
      _ref5$isGrowthSuite = _ref5.isGrowthSuite,
      isGrowthSuite = _ref5$isGrowthSuite === undefined ? false : _ref5$isGrowthSuite;

  var recurringMerchItemConfigs = createItemConfigWithAdditionalUnits({
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity
  });

  if (isGrowthSuite) {
    // Growth Suite onboarding is not attached to merch
    return [].concat(_toConsumableArray(recurringMerchItemConfigs));
  }

  var onboardingItemConfigs = createOnboardingItemConfig({
    merchandiseId: merchandiseId,
    requiredOnboarding: requiredOnboarding
  });

  return [].concat(_toConsumableArray(recurringMerchItemConfigs), _toConsumableArray(onboardingItemConfigs));
}

function _getAdditionalUnitQuantityFromSuite(hub, merchandiseId) {
  var additionalUnitQuantities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var additionalUnitQuantity = additionalUnitQuantities[hub] || 0;

  // contact-based unit quantities from the suite calculator don't include included contacts
  // so we need to explicitly add it
  if (_HubMap2.default[hub].merchPurchaseType === _PurchaseTypes.CONTACT_BASED) {
    return (0, _merchandiseUtils.includedAdditionalUnits)(merchandiseId) + additionalUnitQuantity;
  }

  return additionalUnitQuantity;
}

function createSuiteItemConfigs(edition) {
  var additionalUnitQuantities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var hubToMerchIdMap = _SuiteEditionMerchIdMap2.default[edition];

  var itemConfigs = [];

  Object.keys(hubToMerchIdMap).forEach(function (hub) {
    var merchandiseId = hubToMerchIdMap[hub];
    var additionalUnitQuantity = _getAdditionalUnitQuantityFromSuite(hub, merchandiseId, additionalUnitQuantities);

    itemConfigs = itemConfigs.concat(createItemConfigWithAdditionalUnits({
      merchandiseId: merchandiseId,
      additionalUnitQuantity: additionalUnitQuantity
    }));
  });

  return itemConfigs;
}

function createSuiteItemConfigsWithRequiredOnboarding(edition) {
  var additionalUnitQuantities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var requiredOnboardingMerchId = _GrowthSuiteEditionOnboardingMerchIdMap2.default[edition];

  var itemConfigurations = createSuiteItemConfigs(edition, additionalUnitQuantities);

  if (requiredOnboardingMerchId) {
    itemConfigurations.push(createItemConfigObject({
      merchandiseId: requiredOnboardingMerchId
    }));
  }

  return itemConfigurations;
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/itemConfigUtils.js
// module id = 128
// module chunks = 3 4 5